import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';
import keys from '../show/keys';
import useApiMutation from '../useApiMutation';
import useMessage from '../../useMessage';

const useSetPlusTiers = () => {
  const { message } = useMessage();
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId }) => `/plus/shows/${showId}/episodes`,
    method: 'POST',
    onSuccess: (newEpisodeData) => {
      queryClient.setQueryData(keys(newEpisodeData.showId).acastPlusTiers, newEpisodeData);
    },
    onError: () => {
      message.danger({
        content: (
          <FormattedMessage defaultMessage="There was an error while updating the episode tiers." />
        ),
      });
    },
  });

  return {
    setEpisodesTiers: mutation.mutateAsync,
    ...mutation,
  };
};

export default useSetPlusTiers;
